<template>
  <div class="theme-controls">
    <button 
      class="ui icon button theme-toggle-btn"
      :title="isDarkMode ? 'Light Mode' : 'Dark Mode'"
      @click="toggleMode"
    >
      <i :class="isDarkMode ? 'sun icon' : 'moon icon'"></i>
    </button>

    <div class="theme-color-dropdown">
      <button 
        class="ui icon button color-trigger"
        @click="isOpen = !isOpen"
      >
        <i class="palette icon"></i>
      </button>
      <div v-if="isOpen" class="color-menu">
        <div class="color-header">Theme-Farbe</div>
        <div 
          v-for="color in availablePrimaryColors" 
          :key="color.value"
          class="color-item"
          @click="setPrimaryColor(color.value)"
        >
          <i class="circle icon" :style="{ color: color.value }"></i>
          {{ color.name }}
          <i 
            v-if="currentPrimaryColor === color.value" 
            class="check icon"
            style="margin-left: auto;"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    isDarkMode() {
      return this.$store.state.theme.mode === 'dark'
    },
    currentPrimaryColor() {
      return this.$store.state.theme.primaryColor
    },
    availablePrimaryColors() {
      return this.$store.state.theme.availablePrimaryColors
    }
  },
  mounted() {
    this.$store.dispatch('theme/init')
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleMode() {
      this.$store.dispatch('theme/toggleMode')
    },
    setPrimaryColor(color) {
      this.$store.dispatch('theme/setPrimaryColor', color)
      this.isOpen = false
    },
    handleClickOutside(event) {
      const dropdown = this.$el
      if (dropdown && !dropdown.contains(event.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>
.theme-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.theme-toggle-btn {
  padding: 0.5rem !important;
}

.color-trigger {
  padding: 0.5rem !important;
}

.theme-color-dropdown {
  position: relative;
}

.color-menu {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 180px;
  background: var(--segmentBackground);
  border: 1px solid var(--solidBorderColor);
  border-radius: var(--borderRadius);
  box-shadow: var(--floatingShadow);
  z-index: 1000;
  margin-top: 0.25rem;
}

.color-header {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--textMutedColor);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.75rem 1rem 0.5rem;
  border-bottom: 1px solid var(--borderColor);
}

.color-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  color: var(--textColor);
  transition: background-color 0.15s ease;
}

.color-item:hover {
  background: var(--tableHoverBackground);
}

.color-item .circle.icon {
  font-size: 0.75rem;
}
</style>

<style scoped>
.theme-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.theme-toggle-btn {
  padding: 0.5rem !important;
}

.theme-color-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.theme-color-dropdown .menu {
  min-width: 180px;
}

.theme-color-dropdown .header {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--textMutedColor);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.theme-color-dropdown .item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.theme-color-dropdown .circle.icon {
  font-size: 0.75rem;
}
</style>